export interface FileSchema {
  id: string;
  name: string;
  caption: string;
  url: string;
  size: string;
  type: string;
  length: string;
  verifying_status: FileStatusEnum;
  updated_at: string;
  created_at: string;
}
export enum FileStatusEnum {
  PENDING = "pending",
  VERIFIED = "verified",
  REJECTED = "rejected",
  CANCELED = "canceled",
}
